import { Base64 } from 'js-base64';
import urlParse from 'url-parse';

export default function getUserNameByPathParams() {
  return Base64.decode(urlParse(window.location.href, true).query.username);
}
